import { NavLink } from "react-router-dom"
import { FaArrowCircleLeft } from "react-icons/fa";
import { IconContext } from "react-icons";
import { useState, useEffect } from "react";
import mediaService from "../../services/mediaService";

// Interface pour les médias (images et vidéos)
interface Media {
  id: string;
  url: string;
  description?: string;
  category: string;
  created_at: string;
  resource_type?: string; // 'image' ou 'video'
}

export const Tournage = () => {
  const [medias, setMedias] = useState<Media[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setTimeout(() => {
      const titre = document.getElementById('page-titre');
      if (titre) titre.scrollIntoView({ behavior: 'auto' });
    }, 0);
  }, []);
  
  // Récupérer tous les médias (images + vidéos) depuis Supabase
  useEffect(() => {
    setLoading(true);

    const fetchMedias = async () => {
      try {
        const photos = await mediaService.getByCategory('Tournages');

        if (photos.length > 0) {
          setMedias(photos.map((photo) => ({
            id: photo._id.toString(),
            url: photo.url,
            description: photo.description,
            category: typeof photo.category === 'string' ? photo.category : 'Tournages',
            created_at: typeof photo.created_at === 'string' ? photo.created_at : photo.created_at.toISOString(),
            resource_type: photo.resource_type || 'image',
          })));
        } else {
          setError('Aucun média trouvé pour la catégorie Tournages');
        }
      } catch (err: any) {
        console.error('Erreur lors de la récupération des médias:', err);
        setError(`Erreur: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };
    
    fetchMedias();
  }, []);
  
  return (
    <main className="min-h-screen bg-[#0B0B0F] text-white">
      <div className="p-5">
        <IconContext.Provider value={{size: "2em"}}>
          <NavLink to={'/'} className="text-white hover:text-gray-400 transition-colors"><FaArrowCircleLeft /></NavLink>
        </IconContext.Provider>
      </div>
      
      {/* Titre de la page en haut */}
      <div className="pt-6 pb-4 text-center">
        <h1 id="page-titre" className="text-4xl md:text-5xl font-bold text-white tracking-tight">TOURNAGES</h1>
        <div className="w-24 h-1 bg-white mx-auto mt-4 mb-8"></div>
      </div>

      <div className="container mx-auto px-4 py-8">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white"></div>
          </div>
        ) : error ? (
          <div className="text-center text-red-400 py-8">
            <p>{error}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {medias.map((media, index) => (
              <div key={media.id || index} className="bg-gray-900 rounded-lg overflow-hidden shadow-lg">
                {media.resource_type === 'video' || media.url.includes('.mp4') || media.url.includes('.webm') || media.url.includes('.mov') ? (
                  <video
                    className="w-full h-64 object-cover"
                    src={media.url}
                    controls
                    muted
                    poster={media.url.replace(/\.[^/.]+$/, ".jpg")}
                  />
                ) : (
                  <img
                    className="w-full h-64 object-cover"
                    src={media.url}
                    alt={media.description || `Tournage ${index + 1}`}
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
};
